import { FC, FormEvent } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { useResetPassword } from "../model/useResetPassword";

import styles from "./ResetPasswordPage.module.css";

export const ResetPasswordPage: FC = () => {
  const history = useHistory();
  const location = useLocation();
  const token = new URLSearchParams(location.search).get("token") ?? "";

  const {
    password,
    setPassword,
    confirmPassword,
    setConfirmPassword,
    submit,
    isSubmitting,
    errorMessage,
    isSuccess,
  } = useResetPassword(token);

  const handleSubmit = (event: FormEvent) => {
    event.preventDefault();
    submit();
  };

  if (!token) {
    return (
      <div className={styles.container}>
        <div className={styles.card}>
          <p className={styles.error}>Invalid or missing reset link.</p>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.container}>
      <div className={styles.card}>
        <h2 className={styles.title}>Set a new password</h2>
        {isSuccess ? (
          <>
            <p className={styles.status}>Your password has been reset.</p>
            <button
              type="button"
              className={styles.submitButton}
              onClick={() => history.push("/login")}
            >
              Go to login
            </button>
          </>
        ) : (
          <form className={styles.form} onSubmit={handleSubmit}>
            <input
              className={styles.input}
              type="password"
              value={password}
              onChange={(event) => setPassword(event.target.value)}
              placeholder="New password"
              autoFocus
            />
            <input
              className={styles.input}
              type="password"
              value={confirmPassword}
              onChange={(event) => setConfirmPassword(event.target.value)}
              placeholder="Confirm new password"
            />
            {errorMessage && <p className={styles.error}>{errorMessage}</p>}
            <button
              type="submit"
              className={styles.submitButton}
              disabled={isSubmitting || !password || !confirmPassword}
            >
              {isSubmitting ? "Resetting..." : "Reset password"}
            </button>
          </form>
        )}
      </div>
    </div>
  );
};
